module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    attrs: {
      "id": "eventlist"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowEmptyList),
      expression: "isShowEmptyList"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": require("../../../static/img/icon_no_matching_result.svg")
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "agent-list",
      attrs: {
        "value": _vm.list
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3"
    }, [(item.photo == '') ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": require("../../../static/img/img_device_user_default.png")
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.photo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-6 col-sm-10 col-xs-9 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.user))]), _vm._v(" "), _c('p', {
      staticClass: "device-user-list-devicename"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(item.time)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 btn-device-user-list"
    }, [_c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(_vm._f("capitalize")(item.cmdname)))])])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("No event found.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae480c68", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae480c68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/EventList.vue
// module id = 492
// module chunks = 1